/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landskin_9_TitleInputs */

const en_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumpkin Candy`)
};

const ar_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حلوى القرع العسلى`)
};

const de_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kürbisbonbons`)
};

const es_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caramelos de calabaza`)
};

const fr_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonbons de citrouille`)
};

const it_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caramelle di zucca`)
};

const ja_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`かぼちゃキャンディ`)
};

const ko_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`호박 사탕`)
};

const pt_br_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doces de abóbora`)
};

const ru_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тыквенные конфеты`)
};

const th_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลูกอมฟักทอง`)
};

const tr_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balkabağı Şekerleri`)
};

const zh_cn_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南瓜彩糖`)
};

const zh_tw_landskin_9_title = /** @type {(inputs: Landskin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南瓜彩糖`)
};

/**
* | output |
* | --- |
* | "Pumpkin Candy" |
*
* @param {Landskin_9_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const landskin_9_title = /** @type {((inputs?: Landskin_9_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landskin_9_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landskin_9_title(inputs)
	if (locale === "ar") return ar_landskin_9_title(inputs)
	if (locale === "de") return de_landskin_9_title(inputs)
	if (locale === "es") return es_landskin_9_title(inputs)
	if (locale === "fr") return fr_landskin_9_title(inputs)
	if (locale === "it") return it_landskin_9_title(inputs)
	if (locale === "ja") return ja_landskin_9_title(inputs)
	if (locale === "ko") return ko_landskin_9_title(inputs)
	if (locale === "pt_br") return pt_br_landskin_9_title(inputs)
	if (locale === "ru") return ru_landskin_9_title(inputs)
	if (locale === "th") return th_landskin_9_title(inputs)
	if (locale === "tr") return tr_landskin_9_title(inputs)
	if (locale === "zh_cn") return zh_cn_landskin_9_title(inputs)
	return zh_tw_landskin_9_title(inputs)
});